<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="pn"><span class="epub-bi">ONE</span></p>
<p class="pep">In early 2001, having saddled the pharmaceutical giant with huge debt and cut its workforce by a third, Vaughan’s Oberon Capital Group sold Eiben-Chemcorp for a profit of $457 million. It appears, however, that Oberon did this in the full knowledge that an R&amp;D scandal involving leaked samples of a trial “smart drug” was brewing at Eiben. What is more—and is perhaps more shocking—they then shorted the buyer’s stock in order to make a double killing on the transaction.</p>
<p class="pepc">—<span class="epub-i">House of Vaughan</span> (p. 23)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?bdca7c96